import RejectRegistrationDialogContainer from "./rejectRegistrationDialog.container";

export default RejectRegistrationDialogContainer;
